// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-loader2',
    // #endregion
    // #region Props
    props: {
        isActive: {
            type: Boolean,
            required: false,
            default: true
        },
        size: {
            type: String,
            required: false,
            default: '50px'
        },
        color: {
            type: String,
            required: false,
            default: 'primary'
        },
    },
    // #endregion
});
// #endregion
